/**
 * Open-redirect guard for the `returnUrl` round-trip through /auth/login.
 *
 * Single source of truth — the guard, the interceptor's logout path and the
 * login component all funnel through here. Two copies of a security check
 * drift; this one closes `/\host` too (browsers normalise the backslash to
 * `//host`, so it is protocol-relative in practice even though the sink is
 * currently the internal router rather than location.href).
 *
 * The query string is dropped on purpose: the attempted URL can carry patient
 * ids or filter state, and the result is placed in a `returnUrl` query param
 * that ends up in referrers and server logs.
 */
export function safeReturnUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  const path = url.split(/[?#]/)[0];
  if (!path.startsWith('/')) return null;
  if (path.startsWith('//') || path.startsWith('/\\')) return null;
  if (path === '/auth' || path.startsWith('/auth/')) return null;
  return path;
}
